<template>
  <div>
    <mdb-navbar
      color="primary-color-dark"
      dark
      expand="lg"
      position="top"
      scrolling
    >
      <div class="col px-0 d-flex justify-content-between">
        <router-link to="/">
          <mdb-navbar-brand class="d-inline-block">
            Admisión
          </mdb-navbar-brand>
        </router-link>
        <div class="nav-item ripple-parent d-inline-block d-lg-none">
          <span
            class="nav-link navbar-link cursor-pointer"
            title="Notificaciones"
            @click="showNotifications = !showNotifications"
          >
            <font-awesome-icon
              :icon="['fas', 'bell']"
              size="lg"
              class="d-inline-block white-text w-27px"
            />
            <mdb-badge
              v-if="notificaciones.length"
              tag="small"
              color="danger"
              class="hover-bell"
              pill
            >
              {{ notificaciones.length }}
            </mdb-badge>
          </span>
        </div>
      </div>
      <mdb-navbar-toggler>
        <mdb-navbar-nav
          right
        >
          <mdb-nav-item
            v-if="$route.path != '/login'"
            to="/"
            exact
          >
            <font-awesome-icon
              :icon="['fas', 'tachometer-alt']"
              size="lg"
              class="d-inline-block d-lg-none w-27px"
            />
            Dashboard
          </mdb-nav-item>
          <mdb-nav-item
            v-if="$route.path != '/login'"
            to="/pagos-por-confirmar"
            exact
          >
            <font-awesome-icon
              :icon="['fas', 'file-invoice']"
              size="lg"
              class="d-inline-block d-lg-none w-27px"
            />
            Pagos
          </mdb-nav-item>
          <mdb-nav-item
            v-if="$route.path != '/login'"
            to="/documentos"
            exact
          >
            <font-awesome-icon
              :icon="['fas', 'file-alt']"
              size="lg"
              class="d-inline-block d-lg-none w-27px"
            />
            Documentos
          </mdb-nav-item>
          <mdb-nav-item
            v-if="$route.path != '/login'"
            to="/requisitos"
            exact
          >
            <font-awesome-icon
              :icon="['fas', 'clipboard-list']"
              size="lg"
              class="d-inline-block d-lg-none w-27px"
            />
            Requisitos
          </mdb-nav-item>
          <mdb-nav-item
            v-if="$route.path != '/login'"
            to="/solicitudes"
            exact
          >
            <font-awesome-icon
              :icon="['fas', 'inbox']"
              size="lg"
              class="d-inline-block d-lg-none w-27px"
            />
            Solicitudes
          </mdb-nav-item>
          <mdb-nav-item
            v-if="$route.path != '/login'"
            to="/plantillas"
            exact
          >
            <font-awesome-icon
              :icon="['fas', 'mail-bulk']"
              size="lg"
              class="d-inline-block d-lg-none w-27px"
            />
            Plantillas
          </mdb-nav-item>
          <mdb-nav-item
            v-if="$route.path != '/login'"
            to="/invitar"
            exact
          >
            <font-awesome-icon
              :icon="['fas', 'envelope-open-text']"
              size="lg"
              class="d-inline-block d-lg-none w-27px"
            />
            Invitar
          </mdb-nav-item>
          <li
            class="nav-item ripple-parent d-none d-lg-block"
            @click="showNotifications = !showNotifications"
          >
            <span
              class="nav-link navbar-link cursor-pointer"
              title="Notificaciones"
            >
              <font-awesome-icon
                :icon="['fas', 'bell']"
                size="lg"
                class="d-inline-block w-27px"
              />
              <mdb-badge
                v-if="notificaciones.length"
                tag="small"
                color="danger"
                class="hover-bell"
                pill
              >
                {{ notificaciones.length }}
              </mdb-badge>
            </span>
          </li>
          <mdb-nav-item
            v-if="$route.path != '/login'"
            to="/login"
            exact
            @click="logout"
          >
            <font-awesome-icon
              :icon="['fas', 'sign-in-alt']"
              size="lg"
              class="d-inline-block d-lg-none w-27px"
            />
            Salir
          </mdb-nav-item>
          <!-- Enlaces de las redes sociales
          <mdb-nav-item
            new-tab
            href="#"
          >
            <font-awesome-icon
              :icon="['fab', 'facebook-square']"
              size="lg"
              class="w-27px"
            />
            <span class="ml-1 d-inline-block d-lg-none">Facebook</span>
          </mdb-nav-item>
          <mdb-nav-item
            new-tab
            href="#"
          >
            <font-awesome-icon
              :icon="['fab', 'instagram']"
              size="lg"
              class="w-27px"
            />
            <span class="ml-1 d-inline-block d-lg-none">Instagram</span>
          </mdb-nav-item>
          <mdb-nav-item
            new-tab
            href="#"
          >
            <font-awesome-icon
              :icon="['fab', 'twitter-square']"
              size="lg"
              class="w-27px"
            />
            <span class="ml-1 d-inline-block d-lg-none">Twitter</span>
          </mdb-nav-item>
          -->
        </mdb-navbar-nav>
      </mdb-navbar-toggler>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeInRight"
        leave-active-class="animated fadeOutRight"
      >
        <Notificaciones
          v-if="showNotifications"
          :notificaciones-l="notificaciones"
          @notificaciones-borrar="notificacionesBorrar"
          @cerrar="showNotifications = !showNotifications"
        />
      </transition>
    </mdb-navbar>
  </div>
</template>
<script>
import {mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem,
  mdbBadge} from 'mdbvue';
import Notificaciones from '@/components/Notificaciones.vue';
import {onLogout} from '@/vue-apollo.js';

export default {
  name: 'Navbar',
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbBadge,
    Notificaciones,
  },
  mixins: [Notificaciones],
  data() {
    return {
      showNotifications: false,
      notificaciones: [],
    };
  },
  mounted() {
    this.comprobarCompatibilidad();
  },
  methods: {
    logout() {
      onLogout(this.$apolloProvider.clients.defaultClient);
      this.$router.push('/login');
    },
    notificacionesBorrar() {
      this.notificaciones = [];
    },
  },
};
</script>
<style lang="scss">
  nav ul.navbar-nav li.nav-item a.active.nav-link.navbar-link {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .w-27px { width: 27px !important; }
  .hover-bell {
    position: absolute;
    right: 0;
    top: 0;
  }
</style>
